import { createSelector } from 'reselect';
import { AppState } from '../utils';

const getAllToastsSelector = (state: AppState) => state.toasts.all;

export const getAllToasts = createSelector(
  [getAllToastsSelector],
  (toasts) => toasts,
);
